<template>
  <div class="history">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检查业务台账</span>
      </div>
      <!-- 筛选 -->
      <el-row>
        <!-- 搜索条件 -->
        <el-col :span="3">
          <el-input
            v-model="partyaName"
            placeholder="请输入甲方名称"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="projectName"
            placeholder="请输入项目名称"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="deviceName"
            placeholder="请输入设备名称"
          ></el-input>
        </el-col>
        <!-- 时间选择 -->
        <el-col :span="7">
          <el-date-picker
            v-model="pickerDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            unlink-panels
            :picker-options="pickerOptions"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>
        <!-- 搜索 -->
        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col>
        <el-col :span="6">&nbsp;</el-col>
        <!-- 下载 -->
        <el-col :span="1">
          <el-button
            v-if="tableData.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 筛选 -->
      <!-- <TzTable :tableData="tableDatas" :columns="columns" /> -->
      <el-table :data="tableData" border style="width: 100%" ref="table">
        <el-table-column
          v-for="(item, i) in column"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
          width="110"
        >
        </el-table-column>
        <template v-if="problemSize > 0">
          <el-table-column
            v-for="(item, i) in problemColumn"
            :key="i"
            :prop="item.prop"
            :label="item.label"
            sortable
          >
          </el-table-column
        ></template>

        <el-table-column
          v-for="(item, i) in columns"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
    </el-card>
  </div>
</template>

<script>
import fileDownload from 'js-file-download'
import { listDeviceQuestion, deviceQuestionExport } from '@/api/inspect'
export default {
  data() {
    return {
      partyaName: '', //甲方名称
      deviceName: '', //搜索的设备名称
      projectName: '', // 项目名称
      dialogVisible: false,
      downloadLoading: false,
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: '',
      problemSize: '', //问题数
      // 表格列
      column: [
        {
          label: '工地序号',
          prop: 'projectNameNum'
        },
        {
          prop: 'quarter',
          label: '季度'
        },
        {
          prop: 'projectName',
          label: '工程名称'
        },
        {
          prop: 'place',

          label: '地点'
        },
        {
          prop: 'constructionUni',
          label: '施工单位'
        },
        {
          prop: 'constructionControlUnit',
          label: '监理单位'
        },
        {
          prop: 'deviceNum',
          label: '设备编号'
        },
        {
          prop: 'partyaName',
          label: '甲方单位'
        },
        {
          prop: 'leasingUnit',
          label: '租赁单位'
        },
        {
          prop: 'installUnit',
          label: '安装单位'
        },
        {
          prop: 'maintenanceUnit',
          label: '维保单位'
        },
        {
          prop: 'createTime',
          label: '生产日期'
        },
        {
          prop: 'createUnit',
          label: '生产单位'
        },
        {
          prop: 'checkNum',
          label: '检查编号'
        },
        {
          prop: 'deviceModel',
          label: '设备及型号'
        },
        {
          prop: 'type',
          label: '类型'
        },
        {
          prop: 'anun',
          label: 'A数量'
        },
        {
          prop: 'bnum',
          label: 'B数量'
        },
        {
          prop: 'cnum',
          label: 'C数量'
        },
        {
          prop: 'totalHiddenDangers',
          label: '隐患总数'
        },
        {
          prop: 'totalScore',
          label: '评分'
        },
        {
          prop: 'isDangerous',
          label: '危险设备'
        },
        {
          prop: 'checkUser',
          label: '检查人员'
        },
        {
          prop: 'entryStaff',
          label: '录入人员'
        },
        // {
        //   prop: 'deviceId',
        //   label: '设备id'
        // },
        {
          prop: 'problems',
          label: '问题总结'
        },
        {
          prop: 'defectContent',
          label: '缺陷内容'
        }
      ],
      problemColumn: [],
      columns: [],
      tableData: [],
      pickerDate: [], //日期 时间戳
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  mounted() {
    this.listDeviceQuestion()
  },
  created() {
    // this.listDeviceQuestion()
  },
  // computed: {
  //   columnList: function () {
  //     return this.column.((item) => {
  //       return item.show
  //     })
  //   }
  // },
  methods: {
    handleClick(row) {
      console.log(row)
    },
    handleSizeChange(val) {
      this.limit = val
      // console.log(this.limit, this.page)
      this.listDeviceQuestion()
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.page = val
      // console.log(this.limit, this.page)
      this.listDeviceQuestion()
      // console.log(`当前页: ${val}`)
    },
    //选择日期事件
    handleDateChange(pickerDate) {
      if (pickerDate == null) {
        this.pickerDate = []
      }
    },
    // 点击搜索
    search() {
      this.page = 1
      console.log(this.partyaName, this.deviceName, this.projectName)
      this.listDeviceQuestion()
    },
    listDeviceQuestion() {
      var data = {
        deviceName: this.deviceName,
        partyaName: this.partyaName,
        projectName: this.projectName,
        startTime: this.pickerDate ? this.pickerDate[0] || '' : '',
        endTime: this.pickerDate ? this.pickerDate[1] || '' : '',
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }

      listDeviceQuestion(data).then((res) => {
        this.columns = []
        this.problemColumn = []
        this.total = res.data.total
        this.tableData = res.data.rows
        this.problemSize = res.data.maxSize
        console.log(res.data.total)
        let problem = res.data.problem
        if (res.data.total == 0) {
          this.$message({
            message: '暂无数据'
          })
        }

        //问题
        for (let index = 0; index < this.problemSize; index++) {
          let proObj = {
            label: '问题' + (index + 1),
            prop: (index + 1).toString()
          }
          this.problemColumn.push(proObj)
        }
        // 不固定表头
        problem.forEach((element) => {
          let obj = {
            label: element,
            prop: element
          }
          this.columns.push(obj)
        })

        this.tableData.forEach((item) => {
          Object.assign(item, item.position)
          Object.assign(item, item.problem)
        })
        // console.log(this.tableData)
      })
    },
    download() {
      this.downloadLoading = true
      console.log(this.partyaName, this.deviceName)
      var data = {
        deviceName: this.deviceName,
        partyaName: this.partyaName,
        projectName: this.projectName,
        startTime: this.pickerDate ? this.pickerDate[0] || '' : '',
        endTime: this.pickerDate ? this.pickerDate[1] || '' : ''
      }
      deviceQuestionExport(data).then((res) => {
        fileDownload(res, '检查业务台账.xlsx')
      })
      this.downloadLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
el-col {
}
a {
  color: cornflowerblue;
  text-decoration: none;
}
</style>
